import { AlmeResponseNext } from "@alme/types/response/AlmeResponse";
import { AlmeApiUtils } from "../../api/AlmeApiUtils";
import { AlmeAppState } from "./AlmeAppState";
import defaultLogger from '../../Logger';
import { Dispatch, SetStateAction } from "react";
import { CookieLoader } from "@alme/storage-ts/CookieLoader";
import { ChangeTenantAppEvent } from "../ResponseActions/ChangeTenantConfirmation/ChangeTenantConfirmation";
import { processLiveChatStartAction } from "../ResponseActions/AlmeLiveChatStart/AlmeLiveChatStartUtils";
import { processLiveChatEndAction } from "../ResponseActions/AlmeLiveChatEnd/AlmeLiveChatEndUtils";

export async function loadAlmeHistory(almeApiUtils: AlmeApiUtils, almeState: AlmeAppState, setShouldDisplayTimeout?: Dispatch<SetStateAction<boolean>>): Promise<AlmeResponseNext[]> {
    let curHistory: AlmeResponseNext[] = [];
    const changeTenantAppEvent = new CookieLoader<ChangeTenantAppEvent>('changeTenantAppEvent');
    const inputToResend = new CookieLoader<string>('inputToResend');

    try {
        curHistory = await almeApiUtils.loadAlmeHistory();
        if (!curHistory.length) {
            try {
                curHistory = [];
                const params = {
                    launchPointName: almeState.launchData?.message?.launchPointName,
                    launchParameter: almeState.launchData?.message?.launchParameter,
                    launchType: almeState.launchData?.message?.launchType,
                };
                const welcomeResponse = await almeApiUtils.sendAppEvent('WelcomeUser', 'Internal', params);
                if (welcomeResponse) {
                    curHistory.push(welcomeResponse);
                    if (setShouldDisplayTimeout)
                        setShouldDisplayTimeout(true);
                }
            } catch (error) {
                defaultLogger.error(error);
            }
        } else {
            curHistory = await handleTenantChange(almeApiUtils, curHistory, changeTenantAppEvent, inputToResend);
            curHistory = disableAutoNav(curHistory);
        }
    } catch (error) {
        defaultLogger.error(error);
    }

    return curHistory;
}

export function processLastResponse(almeState: AlmeAppState, setAlmeStateWrapper: (state: AlmeAppState) => void): AlmeResponseNext | undefined {
    let lastResponse;
    if (almeState?.history?.length) {
        lastResponse = almeState.history[almeState.history.length - 1];
    }

    if (lastResponse) {
        // Process last history item item for LiveChatStart Response Action.
        processLiveChatStartAction(lastResponse, almeState, setAlmeStateWrapper);
        processLiveChatEndAction(lastResponse, almeState, setAlmeStateWrapper);
    }
    return lastResponse;
}

function disableAutoNav(curHistory: AlmeResponseNext[]) {
    // Disable all auto navigation on history load.
    for (const response of curHistory) {
        if (response?.navUrl) {
            response.navUrl.AutoNavigationType = 'None';
        }
    }
    return curHistory;
}

async function handleTenantChange(almeApiUtils: AlmeApiUtils, curHistory: AlmeResponseNext[], changeTenantAppEvent: CookieLoader<ChangeTenantAppEvent>, inputToResend: CookieLoader<string>) {
    const tenantAppEvent = changeTenantAppEvent.GetStorage();
    const inputResend = inputToResend.GetStorage();

    if (tenantAppEvent && inputResend) {
        const tenantResponse = await almeApiUtils.sendAppEvent(tenantAppEvent.Name, 'Internal', tenantAppEvent.parameters);
        if (tenantResponse) {
            curHistory.push(tenantResponse);
        }
        changeTenantAppEvent.ClearStorage();
        const resendResponse = await almeApiUtils.sendAlmeInput(inputResend);
        if (resendResponse) {
            curHistory.push(resendResponse);
        }
        inputToResend.ClearStorage();
    }

    return curHistory;
}
